var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSafeIcon = function SvgSafeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    fill: "none",
    viewBox: "0 0 17 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.5 0 0 2.833v8.5a8.5 8.5 0 0 0 8.5 8.5 8.5 8.5 0 0 0 8.5-8.5v-8.5zm6.906 11.333a6.907 6.907 0 0 1-13.812 0V4.03L8.5 1.594l6.906 2.435z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.543 9.1a.795.795 0 0 0-1.36.563.8.8 0 0 0 .233.564l2.865 2.864.046.046a.75.75 0 0 0 1.065 0l4.947-4.947a.75.75 0 0 0 0-1.064l-.062-.062a.75.75 0 0 0-1.065 0l-4.354 4.351z"
  })));
};
export default SvgSafeIcon;